import { type Href, useNavigationContainerRef, useRouter } from 'expo-router'
import React, { useEffect } from 'react'

export const useSafeNavigate = () => {
  const { isReady, addListener } = useNavigationContainerRef()
  const router = useRouter()
  const [route, setRoute] = React.useState<
    { href: Href; options?: Parameters<typeof router.navigate>[1] } | undefined
  >()

  const safeNavigate = (href: Href, options?: Parameters<typeof router.navigate>[1]) => {
    if (isReady()) {
      router.navigate(href, options)
    } else {
      setRoute({ href, options })
    }
  }

  useEffect(() => {
    let unsubscribe: VoidFunction | undefined

    if (route) {
      unsubscribe = addListener('ready', () => {
        router.navigate(route.href, route.options)
        setRoute(() => undefined)
      })
    }

    return () => unsubscribe?.()
  }, [addListener, route, router])

  return { safeNavigate }
}
